var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject } from 'aurelia-dependency-injection';
import { NotificationClientService } from '../../../../../services/basics/notification-client.service';
import { I18N } from 'aurelia-i18n';
import { StepEnum, TemplateNames } from '../../../../../models/modules/lotteryplatofrm.models';
import { BrandingPreviewBase } from '../../branding/branding-preview-base';
import { EventAggregator } from 'aurelia-event-aggregator';
import { ResultsBrandingText } from './branding-steps/results/results-branding-text';
import { ResultsBrandingImages } from './branding-steps/results/results-branding-images';
import { ResultsBrandingColors } from './branding-steps/results/results-branding-colors';
import { LobbyBrandingColors } from './branding-steps/lobby/lobby-branding-colors';
import { LobbyBrandingImages } from './branding-steps/lobby/lobby-branding-images';
import { LobbyBrandingText } from './branding-steps/lobby/lobby-branding-text';
import { TokenClient } from '../../../../../services/authentication/token-client.service';
import { LookupClientService } from '../../../../../services/lookups/lookup-client.service';
import { DialogClientService } from '../../../../../services/basics/dialog-client.service';
import { BrandClientService, TemplateType } from '../../../../../services/modules/brand-client.service';
import { AttachmentClientService } from '../../../../../services/modules/attachements-client.service';
import { CartBrandingText } from './branding-steps/cart/cart-branding-text';
import { CartBrandingImages } from './branding-steps/cart/cart-branding-images';
import { CartBrandingColors } from './branding-steps/cart/cart-branding-colors';
import { PurchasesBrandingText } from './branding-steps/purchases/purchases-branding-text';
import { PurchasesBrandingImages } from './branding-steps/purchases/purchases-branding-images';
import { PurchasesBrandingColors } from './branding-steps/purchases/purchases-branding-colors';
import { LobbyBrandingFeatured } from './branding-steps/lobby/lobby-branding-featured';
import { HotLotteryBranding } from './branding-steps/lottery/hot-lottery-branding';
import { CarouselLotteryBranding } from './branding-steps/lottery/carousel-lottery-branding';
import { QuickPlayBranding } from './branding-steps/lottery/quick-play-branding';
import { CacheClient } from '../../../../../services/basics/client-caching.service';
import { LotteryClientService } from '../../../../../services/modules/lottery-client.service';
import { CartBrandingAds } from './branding-steps/cart/cart-branding-ads';
import { ResultsBrandingAds } from './branding-steps/results/results-branding-ads';
import { PurchasesBrandingAds } from './branding-steps/purchases/purchases-branding-ads';
import { LobbyBrandingAds } from './branding-steps/lobby/lobby-branding-ads';
import * as Enumerable from "linq";
import { LobbyConfig } from './branding-steps/lobby/lobby-config';
import { LotteryConfig } from './branding-steps/lobby/lottery-config';
import { ResultsConfig } from './branding-steps/lobby/results-config';
import { TemplateConfig } from './branding-steps/template/template-config';
import { TicketConfig } from './branding-steps/ticket/ticket-config';
import { CarouselScratchcardBranding } from './branding-steps/scratchcards/carousel-scratchcard-brandings';
import { InstantGameCards } from './branding-steps/scratchcards/instant-game-cards';
import { JsonLockClientService } from '../../../../../services/modules/json-lock-client-service';
import { ExternalTermsAndCondtionsConfig } from './branding-steps/external-terms-and-conditions/external-terms-and-conditions-config';
var BrandSiteDialog = /** @class */ (function (_super) {
    __extends(BrandSiteDialog, _super);
    function BrandSiteDialog(element, notificationService, i18N, eventAggregator, lotteryClientService, resultsBrandingText, brandClientService, attachmentClientService, resultsBrandingImages, resultsBrandingColors, lobbyBrandingText, lobbyBrandingImages, lobbyBrandingColors, lobbyBrandingFeatured, cartBrandingText, cartBrandingImages, cartBrandingColors, purchasesBrandingText, purchasesBrandingImages, purchasesBrandingColors, cartBrandingAds, resultsBrandingAds, purchasesBrandingAds, lobbyBrandingAds, ticketConfig, templateConfig, lobbyConfig, lotteryConfig, resultsConfig, externalTermsAndConditionsConfig, hotLotteryBranding, carouselLotteryBranding, carouselScratchcardsBranding, instantGameCards, quickPlayBranding, cacheClient, tokenClientService, lookupClientService, dialogClientService, jsonLockClientService) {
        var _this = _super.call(this, element, notificationService, i18N, eventAggregator, tokenClientService, lookupClientService, dialogClientService, brandClientService, attachmentClientService, cacheClient, jsonLockClientService) || this;
        _this.lotteryClientService = lotteryClientService;
        _this.resultsBrandingText = resultsBrandingText;
        _this.resultsBrandingImages = resultsBrandingImages;
        _this.resultsBrandingColors = resultsBrandingColors;
        _this.lobbyBrandingText = lobbyBrandingText;
        _this.lobbyBrandingImages = lobbyBrandingImages;
        _this.lobbyBrandingColors = lobbyBrandingColors;
        _this.lobbyBrandingFeatured = lobbyBrandingFeatured;
        _this.cartBrandingText = cartBrandingText;
        _this.cartBrandingImages = cartBrandingImages;
        _this.cartBrandingColors = cartBrandingColors;
        _this.purchasesBrandingText = purchasesBrandingText;
        _this.purchasesBrandingImages = purchasesBrandingImages;
        _this.purchasesBrandingColors = purchasesBrandingColors;
        _this.cartBrandingAds = cartBrandingAds;
        _this.resultsBrandingAds = resultsBrandingAds;
        _this.purchasesBrandingAds = purchasesBrandingAds;
        _this.lobbyBrandingAds = lobbyBrandingAds;
        _this.ticketConfig = ticketConfig;
        _this.templateConfig = templateConfig;
        _this.lobbyConfig = lobbyConfig;
        _this.lotteryConfig = lotteryConfig;
        _this.resultsConfig = resultsConfig;
        _this.externalTermsAndConditionsConfig = externalTermsAndConditionsConfig;
        _this.hotLotteryBranding = hotLotteryBranding;
        _this.carouselLotteryBranding = carouselLotteryBranding;
        _this.carouselScratchcardsBranding = carouselScratchcardsBranding;
        _this.instantGameCards = instantGameCards;
        _this.quickPlayBranding = quickPlayBranding;
        _this.lotteries = [];
        _this.lastStep = "lobby";
        _this.lotteryClientService.getLotteries().then(function (results) {
            _this.lotteries = results;
        });
        return _this;
    }
    BrandSiteDialog.prototype.getFilesToSave = function () {
        return [TemplateType.Lobby, TemplateType.Config, TemplateType.Results, TemplateType.Purchases, TemplateType.Cart];
    };
    BrandSiteDialog.prototype.getBrandTemplateInternalName = function () {
        return this.item.template.internalName;
    };
    BrandSiteDialog.prototype.getBrandThemeInternalName = function () {
        return this.item.brandTheme ? this.item.brandTheme.internalName : null;
    };
    BrandSiteDialog.prototype.getBrandingSteps = function () {
        var _this = this;
        return [{
                title: this.i18N.tr('lobby'),
                step: StepEnum.LobbyBranding,
                show: true,
                view: "",
                children: [
                    {
                        title: this.i18N.tr('lobby-branding-text'),
                        vm: this.lobbyBrandingText,
                        show: true,
                        view: '../../app/admin/brand/dialogs/branding-steps/lobby/lobby-branding-text.html'
                    },
                    {
                        title: this.i18N.tr('lobby-branding-images'),
                        vm: this.lobbyBrandingImages,
                        show: true,
                        view: '../../app/admin/brand/dialogs/branding-steps/lobby/lobby-branding-images.html'
                    },
                    {
                        title: this.i18N.tr('lobby-branding-colors'),
                        vm: this.lobbyBrandingColors,
                        show: true,
                        view: '../../app/admin/brand/dialogs/branding-steps/lobby/lobby-branding-colors.html'
                    },
                    {
                        title: this.i18N.tr('lobby-branding-featured'),
                        vm: this.lobbyBrandingFeatured,
                        show: function () {
                            return _this.brandingModel && _this.brandingModel.templateName &&
                                (_this.brandingModel.templateName.toLowerCase() != TemplateNames.Template2 &&
                                    _this.brandingModel.templateName.toLowerCase() != TemplateNames.Template4 &&
                                    (_this.brandingModel.templateName.toLowerCase() != TemplateNames.Template11));
                        },
                        view: '../../app/admin/brand/dialogs/branding-steps/lobby/lobby-branding-featured.html'
                    },
                    {
                        title: this.i18N.tr('brand-dialog-carousel-lottery'),
                        vm: this.carouselLotteryBranding,
                        show: function () {
                            return _this.brandingModel && _this.brandingModel.templateName &&
                                (_this.brandingModel.templateName.toLowerCase() != TemplateNames.Template11);
                        },
                        view: '../../app/admin/brand/dialogs/branding-steps/lottery/carousel-lottery-branding.html'
                    },
                    {
                        title: this.i18N.tr('instant-scratchcards-top-carousel'),
                        vm: this.carouselScratchcardsBranding,
                        show: function () {
                            return _this.brandingModel && _this.brandingModel.templateName &&
                                (_this.brandingModel.templateName.toLowerCase() == TemplateNames.Template3 || _this.brandingModel.templateName.toLowerCase() == TemplateNames.Template7 || _this.brandingModel.templateName.toLowerCase() == TemplateNames.Template9 || _this.brandingModel.templateName.toLowerCase() == TemplateNames.Template10);
                        },
                        view: '../../app/admin/brand/dialogs/branding-steps/scratchcards/carousel-scratchcard-brandings.html'
                    },
                    {
                        title: this.i18N.tr('brand-dialog-quick-play'),
                        vm: this.quickPlayBranding,
                        show: function () {
                            return _this.brandingModel && _this.brandingModel.templateName &&
                                (_this.brandingModel.templateName.toLowerCase() == TemplateNames.Template7 || _this.brandingModel.templateName.toLowerCase() == TemplateNames.Template8);
                        },
                        view: '../../app/admin/brand/dialogs/branding-steps/lottery/quick-play-branding.html'
                    },
                    {
                        title: this.i18N.tr('brand-dialog-hot-lottery'),
                        vm: this.hotLotteryBranding,
                        show: function () {
                            return _this.brandingModel && _this.brandingModel.templateName &&
                                (_this.brandingModel.templateName.toLowerCase() != TemplateNames.Template11);
                        },
                        view: '../../app/admin/brand/dialogs/branding-steps/lottery/hot-lottery-branding.html'
                    },
                    {
                        title: this.i18N.tr('instant-scratchcards-bottom-carousel'),
                        vm: this.instantGameCards,
                        show: function () {
                            return _this.brandingModel && _this.brandingModel.templateName &&
                                (_this.brandingModel.templateName.toLowerCase() == TemplateNames.Template3 || _this.brandingModel.templateName.toLowerCase() == TemplateNames.Template7 || _this.brandingModel.templateName.toLowerCase() == TemplateNames.Template9 || _this.brandingModel.templateName.toLowerCase() == TemplateNames.Template10);
                        },
                        view: '../../app/admin/brand/dialogs/branding-steps/scratchcards/instant-game-cards.html'
                    }
                ],
                onClick: function (x) {
                    _this.lastStep = "lobby";
                    _this.reloadPreview(_this.lastStep);
                }
            },
            {
                title: this.i18N.tr('results'),
                step: StepEnum.ResultsBranding,
                show: true,
                view: "",
                children: [
                    {
                        title: this.i18N.tr('results-branding-text'),
                        vm: this.resultsBrandingText,
                        show: true,
                        view: '../../app/admin/brand/dialogs/branding-steps/results/results-branding-text.html'
                    },
                    {
                        title: this.i18N.tr('results-branding-images'),
                        vm: this.resultsBrandingImages,
                        show: true,
                        view: '../../app/admin/brand/dialogs/branding-steps/results/results-branding-images.html'
                    },
                    {
                        title: this.i18N.tr('results-branding-colors'),
                        vm: this.resultsBrandingColors,
                        show: true,
                        view: '../../app/admin/brand/dialogs/branding-steps/results/results-branding-colors.html'
                    }
                ],
                onClick: function (x) {
                    _this.lastStep = "results";
                    _this.reloadPreview(_this.lastStep);
                }
            },
            {
                title: this.i18N.tr('purchase'),
                step: StepEnum.PurchasesBranding,
                show: true,
                view: "",
                children: [
                    {
                        title: this.i18N.tr('purchase-branding-text'),
                        vm: this.purchasesBrandingText,
                        show: true,
                        view: '../../app/admin/brand/dialogs/branding-steps/purchases/purchases-branding-text.html'
                    },
                    {
                        title: this.i18N.tr('purchase-branding-images'),
                        vm: this.purchasesBrandingImages,
                        show: true,
                        view: '../../app/admin/brand/dialogs/branding-steps/purchases/purchases-branding-images.html'
                    },
                    {
                        title: this.i18N.tr('purchase-branding-colors'),
                        vm: this.purchasesBrandingColors,
                        show: true,
                        view: '../../app/admin/brand/dialogs/branding-steps/purchases/purchases-branding-colors.html'
                    }
                ],
                onClick: function (x) {
                    _this.lastStep = "purchases";
                    _this.reloadPreview(_this.lastStep);
                }
            },
            {
                title: this.i18N.tr('cart'),
                step: StepEnum.CartBranding,
                show: true,
                view: "",
                children: [
                    {
                        title: this.i18N.tr('cart-branding-text'),
                        vm: this.cartBrandingText,
                        show: true,
                        view: '../../app/admin/brand/dialogs/branding-steps/cart/cart-branding-text.html'
                    },
                    {
                        title: this.i18N.tr('cart-branding-images'),
                        vm: this.cartBrandingImages,
                        show: true,
                        view: '../../app/admin/brand/dialogs/branding-steps/cart/cart-branding-images.html'
                    },
                    {
                        title: this.i18N.tr('cart-branding-colors'),
                        vm: this.cartBrandingColors,
                        show: true,
                        view: '../../app/admin/brand/dialogs/branding-steps/cart/cart-branding-colors.html'
                    }
                ],
                onClick: function (x) {
                    _this.lastStep = "cart";
                    _this.reloadPreview(_this.lastStep);
                }
            }, {
                title: this.i18N.tr('ads'),
                step: StepEnum.BrandAdsBranding,
                show: true,
                view: "",
                children: [
                    {
                        title: this.i18N.tr("lobby-branding-ads"),
                        vm: this.lobbyBrandingAds,
                        show: true,
                        view: '../../app/admin/brand/dialogs/branding-steps/lobby/lobby-branding-ads.html'
                    },
                    {
                        title: this.i18N.tr("results-branding-ads"),
                        vm: this.resultsBrandingAds,
                        show: true,
                        view: '../../app/admin/brand/dialogs/branding-steps/results/results-branding-ads.html'
                    },
                    {
                        title: this.i18N.tr("purchases-branding-ads"),
                        vm: this.purchasesBrandingAds,
                        show: true,
                        view: '../../app/admin/brand/dialogs/branding-steps/purchases/purchases-branding-ads.html'
                    },
                    {
                        title: this.i18N.tr("cart-branding-ads"),
                        vm: this.cartBrandingAds,
                        show: true,
                        view: '../../app/admin/brand/dialogs/branding-steps/cart/cart-branding-ads.html'
                    }
                ]
            }, {
                title: this.i18N.tr('config'),
                step: StepEnum.BrandConfigBranding,
                show: true,
                view: "",
                children: [
                    {
                        title: this.i18N.tr("company-config"),
                        vm: this.ticketConfig,
                        show: true,
                        view: '../../app/admin/brand/dialogs/branding-steps/ticket/ticket-config.html'
                    },
                    {
                        title: this.i18N.tr("template-config"),
                        vm: this.templateConfig,
                        show: true,
                        view: '../../app/admin/brand/dialogs/branding-steps/template/template-config.html'
                    },
                    {
                        title: this.i18N.tr("external-terms-and-conditions-config"),
                        vm: this.externalTermsAndConditionsConfig,
                        show: true,
                        view: '../../app/admin/brand/dialogs/branding-steps/external-terms-and-conditions/external-terms-and-conditions-config.html'
                    },
                    {
                        title: this.i18N.tr("lobby-config"),
                        vm: this.lobbyConfig,
                        show: true,
                        view: '../../app/admin/brand/dialogs/branding-steps/lobby/lobby-config.html'
                    },
                    {
                        title: this.i18N.tr("lottery-config"),
                        vm: this.lotteryConfig,
                        show: true,
                        view: '../../app/admin/brand/dialogs/branding-steps/lobby/lottery-config.html'
                    },
                    {
                        title: this.i18N.tr("results-config"),
                        vm: this.resultsConfig,
                        show: true,
                        view: '../../app/admin/brand/dialogs/branding-steps/lobby/results-config.html'
                    }
                ]
            }];
    };
    BrandSiteDialog.prototype.getBrandDetails = function () {
        return {
            brandId: this.item.brandId,
            brandName: this.item.name,
            brandLanguages: Enumerable.from(this.item.brandLanguages).select(function (x) { return x.languageId; }).toArray()
        };
    };
    BrandSiteDialog.prototype.getRoute = function () {
        return this.lastStep;
    };
    BrandSiteDialog.prototype.getImages = function () {
        var _a, _b, _c, _d, _e;
        var items = [
            this.lobbyBrandingImages.model,
            this.resultsBrandingImages.model,
            (_a = this.lobbyBrandingAds.model) === null || _a === void 0 ? void 0 : _a.image,
            (_b = this.resultsBrandingAds.model) === null || _b === void 0 ? void 0 : _b.image,
            (_c = this.purchasesBrandingAds.model) === null || _c === void 0 ? void 0 : _c.image,
            (_d = this.cartBrandingAds.model) === null || _d === void 0 ? void 0 : _d.image
        ];
        if ((_e = this.ticketConfig.model) === null || _e === void 0 ? void 0 : _e.image) {
            items.push(this.ticketConfig.model.image);
        }
        return items;
    };
    BrandSiteDialog = __decorate([
        autoinject,
        __metadata("design:paramtypes", [Element, NotificationClientService, I18N, EventAggregator, LotteryClientService,
            ResultsBrandingText, BrandClientService, AttachmentClientService,
            ResultsBrandingImages,
            ResultsBrandingColors,
            LobbyBrandingText,
            LobbyBrandingImages,
            LobbyBrandingColors,
            LobbyBrandingFeatured,
            CartBrandingText,
            CartBrandingImages,
            CartBrandingColors,
            PurchasesBrandingText,
            PurchasesBrandingImages,
            PurchasesBrandingColors,
            CartBrandingAds,
            ResultsBrandingAds,
            PurchasesBrandingAds,
            LobbyBrandingAds,
            TicketConfig,
            TemplateConfig,
            LobbyConfig,
            LotteryConfig,
            ResultsConfig,
            ExternalTermsAndCondtionsConfig,
            HotLotteryBranding,
            CarouselLotteryBranding,
            CarouselScratchcardBranding,
            InstantGameCards,
            QuickPlayBranding, CacheClient,
            TokenClient, LookupClientService, DialogClientService,
            JsonLockClientService])
    ], BrandSiteDialog);
    return BrandSiteDialog;
}(BrandingPreviewBase));
export { BrandSiteDialog };
